import { forwardRef, createElement } from 'react';
import { useCurrentMenu } from '../Context.js';
import { Item } from '@radix-ui/react-dropdown-menu';
import { useItemStyling, Icon } from './Item.js';

const Link = /*#__PURE__*/forwardRef(function MenuLink(props, ref) {
  const {
    href,
    icon,
    onClick,
    ...otherProps
  } = props;
  const menu = useCurrentMenu();
  const className = useItemStyling({
    disabled: props.disabled,
    indented: !!icon,
    className: props.className
  });

  const handleClick = event => {
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
    menu === null || menu === void 0 ? void 0 : menu.close();
  };

  return createElement(Item, Object.assign({}, otherProps, {
    asChild: true,
    className: className,
    ref: ref,
    onClick: handleClick
  }), createElement("a", {
    href: href,
    target: "_blank"
  }, icon && createElement(Icon, {
    name: icon
  }), props.children));
});

export { Link };
//# sourceMappingURL=Link.js.map
